
import { RequestPaging } from '@/utils/util'
import { Component, Vue } from 'vue-property-decorator'
import LsDialog from '@/components/ls-dialog.vue'
import LsPagination from '@/components/ls-pagination.vue'
import { apiFreightDel, apiFreightLists } from '@/api/setting'
import ExportData from '@/components/export-data/index.vue'
@Component({
    components: {
        LsDialog,
        LsPagination,
        ExportData
    }
})
export default class FreightTemplate extends Vue {
    queryObj = {
        name: '',
        charge_way: ''
    }
    pager = new RequestPaging()
    apiFreightLists = apiFreightLists
    getList(page?: number): void {
        page && (this.pager.page = page)
        this.pager.request({
            callback: apiFreightLists,
            params: {
                ...this.queryObj
            }
        })
    }
    handleReset() {
        this.queryObj = {
            name: '',
            charge_way: ''
        }
        this.getList()
    }

    handleDelete(id: number) {
        apiFreightDel({ id }).then(() => {
            this.getList()
        })
    }

    created() {
        this.getList()
    }
}
